export class Listener {
    static add(_property, _handler) {
        // _property = eventName(_property);
        // let winformObj = ((parent.window || window) as any)["md"] || {};
        let winformObj = (parent.window || window);
        if (!winformObj[_property]) {
            winformObj[_property] = _handler;
        }
        else {
            const oldHandler = winformObj[_property];
            winformObj[_property] = (args) => {
                oldHandler(args);
                _handler(args);
            };
        }
        return true;
    }
    static remove(_property) {
        // _property = eventName(_property);
        return delete (parent.window || window)[_property];
    }
}
